import { DolozkaVplyvov, DolozkaVplyvovApi } from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import { DolozkaVplyvovFormData } from '../../../model/sprievodnyDokument/DolozkaVplyvovFormData';
import Uuid from '../../../model/Uuid';
import dateToString from '../../../function/dateToString';

const client = new DolozkaVplyvovApi(apiConfiguration(evidenciaPrefixPath));

const map = (dolozkaVplyvov: DolozkaVplyvovFormData): DolozkaVplyvov => ({
  ...dolozkaVplyvov,
  terminZaciatkuPpk: dolozkaVplyvov.terminZaciatkuPpk ? dateToString(dolozkaVplyvov.terminZaciatkuPpk) : null,
  terminUkonceniaPpk: dolozkaVplyvov.terminUkonceniaPpk ? dateToString(dolozkaVplyvov.terminUkonceniaPpk) : null,
});

// eslint-disable-next-line import/prefer-default-export
export const createDolozkaVplyvovClient = async (
  uuid: Uuid,
  dolozkaVplyvov: DolozkaVplyvovFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.createDolozkaVplyvov(uuid, map(dolozkaVplyvov), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};

export const updateDolozkaVplyvovClient = async (
  uuid: Uuid,
  dolozkaVplyvov: DolozkaVplyvovFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.editDolozkaVplyvov(uuid, map(dolozkaVplyvov), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};
